<template>
  <div class="financialfirm" >
    <financialfirm-container></financialfirm-container>
  </div>
</template>
<script>
import FinancialfirmContainer from '@/components/financialfirm/Container.vue'
export default {
  name: 'financialfirm',
  data () {
    return {
    }
  },
  components: {
    FinancialfirmContainer
  }
}
</script>
<style lang="stylus">
.financialfirm
  width 100%
  height 100%
  background #F7F9FB
</style>
